let url = "";
let url_paginas_externas = "";
let key_recaptcha = "";
let url_admin = "";

if (process.env.NODE_ENV === "development") {
    url = "https://trio-api.test";
    url_paginas_externas = "http://riskin-backend.test/ext";
    key_recaptcha = "6Le35GcpAAAAAMqkR-LupWwutbD9rGR1ZiOlbX-M";
    url_admin = "http://localhost:300";
} else {
    url = "https://api.riskin.com.br";
    url_paginas_externas = "https://painel.riskin.com.br/ext";
    key_recaptcha = "6Le35GcpAAAAAMqkR-LupWwutbD9rGR1ZiOlbX-M";
    url_admin = "https://painel.riskin.com.br";
}

export const Constants = {
    url: url,
    baseUrl: url + "/api/admin",
    url_paginas_externas: url_paginas_externas,
    key_recaptcha: key_recaptcha,
    url_admin,
};
